export const SELECT_OBJECTS = 'SELECT_OBJECTS'
export const DESELECT_OBJECTS = 'DESELECT_OBJECTS'
export const DELETE_SELECTED_OBJECTS = 'DELETE_SELECTED_OBJECTS'
